var _module = require('../../components/module');
var config = require('config');
var _ = require('lodash');

require('angular-ui-bootstrap/src/modal');
require('angular-input-masks');
require('../lr-touch');
require('../user');
require('../fullscreen-loading');
require('../thankyou-modal');
require('../analytics');
require('../activity-feed');
require('../numbers-only');

_module.requires.push('ui.bootstrap.module.modal', 'ui.utils.masks');

_module.controller('AddBuyerAgentModalCtrl', [
    '$q',
    '$log',
    '$scope',
    '$http',
    '$fsloading',
    '$analytics',
    'benoitUserId',

    function AddBuyerAgentModalCtrl($q, $log, $scope, $http, $fsloading, $analytics, benoitUserId) {
        var abam = this;
        abam.addBuyerAgentForm = {};

        abam.model = {
            addBuyerAgentFormData: {},
            showForm: false,
            loading: false
        };

        abam.events = {
            onNoClick: onNoClick,
            onYesClick: onYesClick,
            onSubmit: onSubmit
        };

        function getAffiliateAgent() {
            if(benoitUserId && benoitUserId.length > 0) {
                var url = '/v1/users/' + benoitUserId + '/affiliate-agent';
                return $http.get(url)
                    .then(function (affiliateResponse) {
                        return _.get(affiliateResponse, 'data.data', null);
                    })
                    .catch(function (err) {
                        $log.error('Error trying to get ' + url, err);
                        return null;
                    });
            } else {
                return $q.when(null);
            }
        }

        function getBuyerAgent() {
            if(benoitUserId && benoitUserId.length > 0) {
                var url = '/v1/users/' + benoitUserId + '/buyer-agent';
                abam.model.loading = true;
                $http.get(url)
                    .then(function (response) {
                        var buyerAgent = _.get(response, 'data.data');
                        if(buyerAgent) {
                            return $q.when(buyerAgent);
                        } else {
                            return getAffiliateAgent();
                        }
                    })
                    .then(function (buyerAgent) {
                        if(buyerAgent) {
                            _.set(abam, 'model.buyerAgentCandidate', buyerAgent);
                        } else {
                            showForm();
                        }
                    })
                    .catch(function (err) {
                        $log.error('Error trying to get ' + url, err);
                        showForm();
                    })
                    .finally(function () {
                        abam.model.loading = false;
                    });
            }
        }

        function saveBuyerAgent(data) {
            var payload = {
                data: _.extend(data, { verified: true })
            };
            var url = '/v1/users/' + benoitUserId + '/update-buyer-agent';
            return $http.post(url, payload)
                .then(onSaveBuyerAgentSuccess)
                .catch(onSaveBuyerAgentError);
        }

        function onSaveBuyerAgentSuccess(response) {
            $log.debug('AddBuyerAgentModalCtrl -> saveBuyerAgent success', response);
            var buyerAgent = _.get(response, 'data.data.buyer_agent', null);
            abam.$close(buyerAgent);
        }

        function onSaveBuyerAgentError(err) {
            $log.debug('AddBuyerAgentModalCtrl -> saveBuyerAgent error', err);
            abam.$dismiss(err);
        }

        function formatBuyerAgentCandidate(bac) {
            var name = _.get(bac, 'name', '');
            var splitName = name.split(' ');
            var firstName = splitName.shift();
            var lastName = splitName.join(' ');

            var formatted = {
                first_name: bac.first_name || firstName,
                last_name: bac.last_name || lastName,
                phone: _.get(bac, 'phone'),
                email: _.get(bac, 'email'),
                company: _.get(bac, 'company'),
                headshot: _.get(bac, 'headshot'),
                realtor_license_type: _.get(bac, 'realtor_license_type'),
                realtor_license_number: _.get(bac, 'realtor_license_number'),
                phone_secondary: _.get(bac, 'phone_secondary'),
                company_address: _.get(bac, 'company_address'),
                branding: _.get(bac, 'branding')
            };

            return formatted;
        }

        function onYesClick() {
            var formattedBuyerAgent = formatBuyerAgentCandidate( _.get(abam, 'model.buyerAgentCandidate', {}) );
            saveBuyerAgent(formattedBuyerAgent);
        }

        function onNoClick() {
            showForm();
        }

        function showForm() {
            abam.model.showForm = true;
        }

        function onSubmit() {
            if(abam.addBuyerAgentForm.$valid) {
                $log.debug('ABAM', abam.model.addBuyerAgentFormData);
                saveBuyerAgent(abam.model.addBuyerAgentFormData);
            }
        }

        function init() {
            getBuyerAgent();
        }

        init();
    }
]);

_module.service('$addBuyerAgentModal', [
    '$log',
    '$http',
    '$location',
    '$timeout',
    '$uibModal',
    '$user',
    '$fsloading',
    '$thankyouModal',
    '$analytics',

    function $addBuyerAgentModal($log, $http, $location, $timeout, $uibModal, $user, $fsloading, $thankyouModal, $analytics) {
        return function openAddBuyerAgentModal(opts) {
            opts = opts || {};
            var windowClass = 'add-buyer-agent-modal';

            var modal = $uibModal.open({
                template: require('./index.html'),
                controller: 'AddBuyerAgentModalCtrl',
                controllerAs: 'abam',
                resolve: {
                    benoitUserId: function () {
                        return opts.id;
                    }
                },
                bindToController: true,
                backdrop: true,
                windowClass: windowClass
            });

            var trackSubmit = function trackSubmit(buyerAgent) {
                var eventName = opts.analyticsEventNameSubmit || '';

                if(buyerAgent && eventName.length && opts.analyticsEventDataSubmit) {
                    var buyerAgentName = [buyerAgent.first_name, buyerAgent.last_name].join(' ');
                    var eventData = _.extend({}, opts.analyticsEventDataSubmit, {
                        'Buyer Agent Name': buyerAgentName,
                        'Buyer Agent Email': buyerAgent.email,
                        'Buyer Agent Phone': buyerAgent.phone,
                        'Buyer Agent Company': buyerAgent.company
                    });

                    $analytics.eventTrack(eventName, eventData);
                }

            };

            modal.result.then(function onClose(response) {
                if(response) {
                    trackSubmit(response);
                    if(opts.showConfirmationModal) {
                        return $thankyouModal('Your buyer agent data has been saved.').result
                            .then(function (res) {
                                return response;
                            });
                    }
                }

                return response;
            });

            return modal;
        };
    }
]);
